import { render, staticRenderFns } from "./PButton.vue?vue&type=template&id=d38a1f90&scoped=true"
import script from "./PButton.vue?vue&type=script&lang=ts"
export * from "./PButton.vue?vue&type=script&lang=ts"
import style0 from "./PButton.vue?vue&type=style&index=0&id=d38a1f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38a1f90",
  null
  
)

export default component.exports